export function getQueryFlag(param: string, defaultIfMissing = false): boolean {
  const url = new URL(document.URL);

  const lowerCaseKey = param.toLowerCase();
  for (const [name, value] of url.searchParams.entries()) {
    if (lowerCaseKey === name.toLowerCase()) {
      return /^(1|true|t|yes|y)$/.test(value.toLowerCase());
    }
  }
  return defaultIfMissing;
}

export function getClientId(location: Location): string | null {
  const hash = location.hash;
  if (hash.length < 2) {
    return null;
  }
  const hashItems = hash.substring(1).split("&");

  return (
    hashItems.find((s) => {
      const itemAsInt = parseInt(s, 10);
      if (s.indexOf("=") < 0 && itemAsInt) {
        return itemAsInt;
      }

      return null;
    }) || null
  );
}
